<h3>Filtros de empleados</h3>

<div class="form-control">
  <label class="text-neutral-900">Grupo</label>
  @if (isLoadingOptions) {
    <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
  } @else {
    <core-select
      [options]="groupOptions"
      [(ngModel)]="filters.groupId"
      placeholder="Todos los grupos"/>
  }
</div>

<div class="form-control">
  <label class="text-neutral-900">Estado</label>
  @if (isLoadingOptions) {
    <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
  } @else {
    <core-select
      [options]="statusOptions"
      [(ngModel)]="filters.status"
      placeholder="Todos los estados"/>
  }
</div>

<div class="form-control">
  <label class="text-neutral-900">Acceso a plataforma</label>
  @if (isLoadingOptions) {
    <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
  } @else {
    <core-select
      [options]="accessOptions"
      [(ngModel)]="filters.accessStatus"
      placeholder="Todos los accesos"/>
  }
</div>

<div class="employee-filters-actions">
  <button (click)="clear()" [disabled]="isBusy" class="btn btn-primary-text" type="button">
    Eliminar filtros
  </button>

  <div class="employee-filters-main-actions">
    <button (click)="close()" class="btn btn-primary-soft" type="button">
      Cancelar
    </button>
    <button (click)="apply()" [disabled]="isBusy" class="btn btn-primary" type="button">
      {{ isBusy ? 'Cargando...' : 'Aplicar filtros' }}
    </button>
  </div>
</div>
